module.exports = __webpack_public_path__ + "static/media/street-food.ab8c480b.jpg";